import React from 'react';
import { setClassNames } from '@ddc/classnames-js';
import PropTypes from 'prop-types';

const VARIANT = {
	OVERLAY: 'overlay',
	TOOLBAR: 'toolbar',
	TOOLBAR_THUMBNAIL: 'toolbar-thumbnail',
	MODAL_TAB: 'modal-tab'
};

const GalleryButton = (props) => {
	const {
		activeToolBar,
		btnLabel,
		btnSpace,
		handleClick,
		variant = VARIANT.TOOLBAR,
		thumbnailUrl,
		value,
		icon,
		iconStyle,
		iconColor
	} = props;

	const isOverlay = variant === VARIANT.OVERLAY;
	const isModalTab = variant === VARIANT.MODAL_TAB;
	const isTextLink =
		variant === VARIANT.OVERLAY ||
		variant === VARIANT.TOOLBAR ||
		variant === VARIANT.MODAL_TAB;
	const isRoundIconStyle = isOverlay && iconStyle === 'round';
	const isLightIconColor = isOverlay && iconColor === 'light';

	const btnOverlayClass = [
		'gallery-button',
		'w-60',
		`${btnSpace}`,
		'gallery-button-overlay',
		isLightIconColor
			? 'gallery-button-overlay--light'
			: 'gallery-button-overlay--dark',
		'py-2',
		'px-3',
		'd-inline-flex align-items-center',
		isLightIconColor ? '' : 'text-white',
		'border-0',
		'line-height-condensed',
		isRoundIconStyle ? 'rounded-circle' : 'border-radius-sm'
	];
	const btnNormalClass = [
		'gallery-button',
		'border-left-0',
		'border-top-0',
		'border-right-0',
		'w-60',
		`${btnSpace}`,
		'bg-transparent',
		'text-body',
		isModalTab && activeToolBar === value
			? 'gallery-button--active p-0'
			: 'gallery-button--inactive p-0',
		isModalTab && activeToolBar !== value && 'text-muted',
		isTextLink ? 'd-flex align-items-center' : ''
	];

	const buttonContent = (
		<>
			{isTextLink ? (
				<i
					data-testid="text-icon"
					aria-hidden="true"
					className={setClassNames([
						'ddc-icon',
						`${icon}`,
						'ddc-icon-size-large',
						isRoundIconStyle ? '' : 'mr-3'
					])}
				/>
			) : (
				<div
					data-testid="thumbnail-icon"
					className={setClassNames([
						'position-relative',
						'gallery-button-thumb-container',
						'mb-3'
					])}
					style={{
						backgroundImage: `url("${thumbnailUrl}")`
					}}
				>
					<div
						className={setClassNames([
							'gallery-button-thumb-bg-icon',
							'position-absolute',
							'rounded-circle'
						])}
					>
						<i
							aria-hidden="true"
							className={setClassNames([
								'ddc-icon',
								`${icon}`,
								'ddc-icon-size-xlarge',
								'text-white'
							])}
						/>
					</div>
				</div>
			)}
			<span
				className={setClassNames([
					'ddc-font-size-xsmall',
					'font-weight-bold',
					isRoundIconStyle ? 'sr-only' : ''
				])}
			>
				{btnLabel}
			</span>
		</>
	);
	return (
		<button
			type="button"
			onClick={handleClick}
			data-testid="gallery-button"
			aria-label={isRoundIconStyle ? btnLabel : undefined}
			className={setClassNames([
				...(isOverlay ? btnOverlayClass : btnNormalClass)
			])}
		>
			{buttonContent}
		</button>
	);
};

GalleryButton.VARIANT = VARIANT;

GalleryButton.propTypes = {
	activeToolBar: PropTypes.string,
	btnLabel: PropTypes.string,
	btnSpace: PropTypes.string,
	handleClick: PropTypes.func,
	icon: PropTypes.string,
	iconStyle: PropTypes.oneOf(['default', 'round']),
	iconColor: PropTypes.oneOf(['dark', 'light']),
	variant: PropTypes.oneOf([
		VARIANT.OVERLAY,
		VARIANT.TOOLBAR,
		VARIANT.TOOLBAR_THUMBNAIL,
		VARIANT.MODAL_TAB
	]),
	thumbnailUrl: PropTypes.string,
	value: PropTypes.string
};

export default GalleryButton;
